module.exports = __webpack_public_path__ + "static/img/nian.909858c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nian.png
// module id = Dp5P
// module chunks = 73